import template from './admin-fax.html';

export default function AdminFax() {
    return {
        restrict: 'A',
        controller: AdminFaxController,
        controllerAs: 'adminFaxCtrl',
        template,
        bindToController: true,
        link,
    };

    function link($scope, $elem, $attrs, adminFaxCtrl) {
        adminFaxCtrl.$onInit();
    }
}

export function AdminFaxController() {
    const vm = this;

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-fax/admin-fax-component.js